import { createContext, type ReactNode } from "react";

import type { IGrowthHeatmapStyle } from "../utils/heatmapScale";

export type TGrowthOverviewHeatmapStyleGetter = (pop: number | null | undefined) => IGrowthHeatmapStyle;

const GrowthOverviewHeatmapContext = createContext<TGrowthOverviewHeatmapStyleGetter | null>(null);

export { GrowthOverviewHeatmapContext };

export const GrowthOverviewHeatmapProvider = ({
    getHeatmapStyle,
    children,
}: {
    getHeatmapStyle: TGrowthOverviewHeatmapStyleGetter;
    children: ReactNode;
}) => <GrowthOverviewHeatmapContext value={getHeatmapStyle}>{children}</GrowthOverviewHeatmapContext>;
